import { useRef, useEffect } from 'react';
import mousetrap from 'mousetrap';

/** Binds a specified keyboard command to a callback method (https://craig.is/killing/mice) */

function useMousetrap(keys, callback, action) {
  var callbackRef = useRef(callback);
  useEffect(function () {
    if (keys !== null) {
      mousetrap.bind(keys, function (event, combo) {
        if (typeof callbackRef.current === 'function') {
          callbackRef.current(event, combo);
        }
      }, action);
    }

    return function () {
      if (keys !== null) {
        mousetrap.unbind(keys);
      }
    };
  }, [keys, action]);
}

export default useMousetrap;
export { useMousetrap };
//# sourceMappingURL=use-mousetrap.esm.js.map
